import { render } from "./DownloadAppPage.vue?vue&type=template&id=e15b1372&scoped=true"
import script from "./DownloadAppPage.vue?vue&type=script&lang=js"
export * from "./DownloadAppPage.vue?vue&type=script&lang=js"

import "./DownloadAppPage.vue?vue&type=style&index=0&id=e15b1372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15b1372"]])

export default __exports__